module.exports = __webpack_public_path__ + "assets/ms-icon-144x144.c0adbb0b.png";